import { Pagination } from '@cloudflare/kumo'

/** 표 아래 고전적인 페이지네이션 — "1–10 of 42" + 이전/다음. 한 페이지에 다 들어가면 그리지 않는다 */
export function TablePagination({
  page,
  setPage,
  perPage,
  total,
}: {
  page: number
  setPage: (page: number) => void
  perPage: number
  total: number
}) {
  if (total <= perPage) return null
  return (
    <Pagination page={page} setPage={setPage} perPage={perPage} totalCount={total}>
      <Pagination.Info />
      <Pagination.Separator />
      <Pagination.Controls />
    </Pagination>
  )
}
